import moment from 'moment'
moment.locale('ru')

export default moment

export const $_app_moment_format = {
  view: 'DD.MM.YYYY',
  save: 'YYYY-MM-DD'
}

export const $_app_moment = {
  computed: {
    getISOToday() {
      return moment().format('YYYY-MM-DD')
    },

    getToday() {
      return moment().format('DD.MM.YYYY')
    },

    getCurrentWeek() {
      let startWeek = moment().startOf('week').format('DD.MM')
      let endWeek = moment().endOf('week').format('DD.MM')
      return  startWeek + ' - ' + endWeek
    },

    getCurrentMonth() {
      return moment().format('MMMM YYYY')
    },

    getCurrentMonthStartEnd() {
      let startMonth = moment().startOf('month').format('DD.MM')
      let endWMonth = moment().endOf('month').format('DD.MM')
      return  startMonth + ' - ' + endWMonth
    },

    $_today () {
      let today = moment().format('YYYY-MM-DD')
      return { text: this.getToday, type: 'day', start: today, end: today }
    },

    $_current_week () {
      let start = moment().startOf('week').format('YYYY-MM-DD')
      let end = moment().endOf('week').format('YYYY-MM-DD')
      return { text: this.getCurrentWeek, type: 'week', start, end }
    },

    $_current_month () {
      let start = moment().startOf('month').format('YYYY-MM-DD')
      let end = moment().endOf('month').format('YYYY-MM-DD')
      return { text: this.getCurrentMonth, type: 'month', start, end }
    },

    $_period_all () { return { title: 'все', action: () => this.$_filterByPeriod(null) }},
    $_period_today () { return { title: `сегодня (${this.$_today.text})`, action: () => this.$_filterByPeriod(this.$_today) }},
    $_period_week () { return { title: `текущая неделя (${this.$_current_week.text})`, action: () => this.$_filterByPeriod(this.$_current_week) }},
    $_period_month () { return { title: `текущий месяц (${this.$_current_month.text})`, action: () => this.$_filterByPeriod(this.$_current_month) }},
    $_period_choose_day () { return { title: `выбрать день`, 'prepend-icon': 'event', action: () => this.$_chooseDay() }},
    $_period_choose_month () { return { title: `выбрать месяц`, 'prepend-icon': 'event', action: () => this.$_chooseMonth() }},
    $_period_choose_period () { return { title: `выбрать период`, action: () => this.$_choosePeriod() }},

    $_period_items () { return [ this.$_period_all, this.$_period_today, this.$_period_week, this.$_period_month, this.$_period_choose_day, this.$_period_choose_month ]},

    $_short_period_items () { return [ this.$_period_today, this.$_period_choose_period ]},
  },

  methods: {
    getMonth (date) {
      return moment( date, 'YYYY-MM' ).format('MMMM YYYY')
    },

    $_shortFormatRu (date) {
      return moment( date, 'YYYY-MM-DD hh:mm' ).format('DD.MM.YYYY')
    },

    $_formatRu (date) {
      return moment( date, 'YYYY-MM-DD HH:mm' ).format('DD.MM.YYYY HH:mm')
    },

    $_filterByPeriod (period) {
      console.log(period)
    },

    $_chooseDay () {
      console.log('Empty method $_chooseDay')
    },

    $_chooseMonth () {
      console.log('Empty method $_chooseMonth')
    },

    $_choosePeriod () {
      console.log('Empty method $_choosePeriod')
    },
  }
}